import { render } from "./SiteDevice.vue?vue&type=template&id=bb44fbd6&ts=true"
import script from "./SiteDevice.vue?vue&type=script&lang=ts"
export * from "./SiteDevice.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__